import { Navigate, useLocation } from 'react-router-dom';

export type LegacyProcurementKind = 'purchase_orders' | 'subrentals';

/**
 * Where an old Purchase Orders or Vendor Rental Inventory link lands now (docs/warehouse.md,
 * "Old links"). Covers the retired Maintenance pages, the old `/transfers/purchase-orders` and
 * `/transfers/xrental-orders` list routes, and the `?poId=` links the purchase-order
 * notification trigger has stored in dashboard_notifications.
 */
export function legacyProcurementTarget(kind: LegacyProcurementKind, search: string): string {
  const params = new URLSearchParams(search);
  if (kind === 'purchase_orders') {
    const poId = params.get('poId')?.trim();
    return poId
      ? `/transfers/purchase-orders/${encodeURIComponent(poId)}`
      : '/transfers?tab=purchase_orders';
  }
  const subrentalId = (params.get('subrentalId') || params.get('xrentalId') || '').trim();
  if (subrentalId) return `/transfers/xrental-orders/${encodeURIComponent(subrentalId)}`;
  // The item editor's "rent from a vendor" shortcut opens New subrental for that item.
  const itemId = params.get('itemId')?.trim();
  if (itemId) {
    const next = new URLSearchParams({ tab: 'subrentals', new: 'equipment', itemId });
    return `/transfers?${next.toString()}`;
  }
  return '/transfers?tab=subrentals';
}

/** Rewrites an old procurement link to its Warehouse tab or record, replacing the history entry. */
export default function LegacyProcurementRedirect({ kind }: { kind: LegacyProcurementKind }) {
  const location = useLocation();
  return <Navigate to={legacyProcurementTarget(kind, location.search)} replace />;
}
